function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M-924-1347H996v2651H-924z"
}), React.createElement("path", {
  d: "M-925-1040H995v2286H-925z"
}), React.createElement("g", {
  transform: "translate(-69.5 -52)"
}, React.createElement("path", {
  fill: "currentColor",
  d: "M136.255 70.897a1.094 1.094 0 1 1 0 2.188 5.83 5.83 0 0 0-5.817 5.46l-.011.369v9.205c0 9.333-7.423 16.931-16.686 17.215l-.537.008H99.087c-9.332 0-16.93-7.423-17.214-16.686l-.008-.537v-9.732a5.302 5.302 0 0 0-5.302-5.302 1.094 1.094 0 1 1 0-2.188 7.49 7.49 0 0 1 7.478 7.079l.011.41v9.733c0 8.131 6.454 14.754 14.518 15.027l.517.008h14.117c8.13 0 14.754-6.453 15.026-14.518l.009-.517v-9.205a8.016 8.016 0 0 1 8.016-8.017zm-21.63 23.406a.875.875 0 1 1 0 1.75h-8.75a.875.875 0 0 1 0-1.75zm8.75 0a.875.875 0 0 1 0 1.75h-5.25a.875.875 0 0 1 0-1.75zm-24.063 0a.875.875 0 0 1 0 1.75h-5.25a.875.875 0 0 1 0-1.75zm21.437-4.374a.875.875 0 1 1 0 1.75h-11.374a.875.875 0 0 1 0-1.75zm-17.5 0a.875.875 0 1 1 0 1.75H91.875a.875.875 0 0 1 0-1.75zm20.125-4.376a.875.875 0 0 1 0 1.75h-10.5a.875.875 0 0 1 0-1.75zm-24.062 0a.875.875 0 0 1 0 1.75h-10.5a.875.875 0 0 1 0-1.75zm10.063 0a.875.875 0 1 1 0 1.75h-5.25a.875.875 0 1 1 0-1.75zM96.25 81.178a.875.875 0 1 1 0 1.75H91a.875.875 0 1 1 0-1.75zm26.249 0a.875.875 0 1 1 0 1.75h-21.873a.875.875 0 0 1 0-1.75zm-24.061-4.374a.875.875 0 0 1 0 1.75h-6.125a.875.875 0 1 1 0-1.75zm10.937 0a.875.875 0 0 1 0 1.75h-6.124a.875.875 0 1 1 0-1.75zm14 0a.875.875 0 0 1 0 1.75H115.5a.875.875 0 1 1 0-1.75z"
})), React.createElement("text", {
  fontFamily: "BNPPSans, BNPP Sans",
  fontSize: 16,
  transform: "translate(-69.5 -56.72)"
}, React.createElement("tspan", {
  x: 76.008,
  y: 138.719
}, "Zbiornik")));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 71,
    height: 71
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/zbiornik.dc9cc285.svg";
export { SvgComponent as ReactComponent };